import { createSlice } from '@reduxjs/toolkit'
import { $authHost } from '../http';
import { check } from '../http/userApi';

// Функция для инициализации состояния авторизации
export const initializeAuth = () => async (dispatch) => {
    const token = localStorage.getItem('token');

    if (token) {
        try {
            dispatch(setIsLoading(true));
            // Проверяем валидность токена
            const userData = await check();
            dispatch(setUser({
                ...userData,
                isAdmin: userData.roles.includes('admin'),
                isAuth: true
            }));
        } catch (error) {
            // Если токен невалиден, удаляем его
            localStorage.removeItem('token');
            dispatch(logoutUser());
        } finally {
            dispatch(setIsLoading(false));
        }
    } else {
        dispatch(setIsLoading(false));
    }
};

export const fetchStateMain = () => async (dispatch) => {
    try {
        $authHost.get('/api/state').then(res => {
            const { data } = res
            console.log('HTTP: Получено состояние:', data)
            dispatch(setObjects(data))
        }).catch(err => {
            dispatch(setError(err.message));
        })

    } catch (err) {
        dispatch(setError(err.message));
    }
};

// Действие для обновления состояния через WebSocket
export const updateStateFromWebSocket = (data) => (dispatch) => {
    console.log('WebSocket: Обновление состояния:', data)
    dispatch(setObjects(data))
};


const initialState = {
    objects: {
        crossroad: [],
        speed: [],
        parking: [],
        deactivated: [],
        vgk: [],
        vehicles: [],
        others: {}
    },
    user: {
        isAuth: false,
        isAdmin: false,
        name: null,
        roles: []
    },
    filter: localStorage.getItem('filter') ? JSON.parse(localStorage.getItem('filter')) : {
        severity: 0,
        hostid: null,
        hostids: [],
        hostids_speed: [],
    },
    currentComplex: {
        hostid: null,
        inventory: {
            location_lat: null,
            location_lon: null
        }
    },
    layers: localStorage.getItem('layers') ? JSON.parse(localStorage.getItem('layers')) : {
        base: 1,
        overlay: {
            crossroad: true,
            speed: true,
            parking: true,
            vgk: true,
            vehicles: true,
            others: {}
        },
        data: {
            paurina: false
        },
        settings: {
            brightness: 100,
            contrast: 100,
            saturation: 100,
            opacity: 100
        }
    },
    isLoading: false,
    error: null
}

export const storeSlice = createSlice({
    name: 'state',
    initialState,
    reducers: {
        setObjects: (state, action) => {
            console.log('setObjects', action.payload)
            state.objects = action.payload
            
            // Обновляем список слоев others на основе полученных данных
            if (action.payload?.others) {
                const others = action.payload.others
                const newOthersLayers = {}
                console.log(state.layers)
                // Проходим по всем тегам в полученных данных
                Object.keys(others).forEach(key => {
                    console.log(key)
                    // Если слой уже существует в othersLayers, сохраняем его состояние
                    // Иначе устанавливаем по умолчанию true (включен)
                    if (state.layers.overlay.others.hasOwnProperty(key)) {
                        newOthersLayers[key] = state.layers.overlay.others[key]
                    } else {
                        newOthersLayers[key] = true
                    }
                })
                
                // Обновляем state.othersLayers только ключами из новых данных
                // Старые ключи, которых нет в новых данных, будут удалены
                state.layers.overlay.others = newOthersLayers
                localStorage.setItem('layers', JSON.stringify(state.layers))
            } else {
                // Если others пустой или отсутствует, очищаем слои
                state.layers.overlay.others = {}
                localStorage.setItem('layers', JSON.stringify(state.layers))
            }
            console.log(state.layers)
        },
        updateObjects: (state, action) => {
            console.log('updateObjects', action.payload)
            state.objects = { ...state.objects, ...action.payload }
        },
        clearObjects: (state) => {
            console.log('clearObjects')
            state.objects = {
                crossroad: [],
                speed: [],
                parking: [],
                vgk: [],
                vehicles: [],
                others: {}
            }
        },
        setUser: (state, action) => {
            console.log('setUser', action.payload)
            state.user = action.payload
        },
        logoutUser: (state) => {
            console.log('logoutUser')
            state.user = { isAuth: false, name: null, roles: [] }
        },
        setFilter: (state, action) => {
            console.log('setFilter', action.payload)
            state.filter = action.payload
            localStorage.setItem('filter', JSON.stringify(state.filter))
        },
        setCurrentComplex: (state, action) => {
            console.log('setCurrentComplex', action.payload)
            state.currentComplex = action.payload
        },
        setIsLoading: (state, action) => {
            console.log('setIsLoading', action.payload)
            state.isLoading = action.payload
        },
        setError: (state, action) => {
            console.log('setError', action.payload)
            state.error = action.payload
        },
        setBaseLayer(state, action) {
            console.log('setBaseLayer', action.payload)
            state.layers.base = action.payload
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },
        setOverlayLayer(state, action) {
            console.log('setOverlayLayer', action)
            if (action.payload.group === 'others') {
                state.layers.overlay.others[action.payload.name] = action.payload.state
            } else {
                state.layers.overlay[action.payload.name] = action.payload.state
            }
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },
        setDataLayer(state, action) {
            console.log('setDataLayer', action.payload)
            state.layers.data[action.payload.name] = action.payload.state
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },
        setMapSettings(state, action) {
            console.log('setMapSettings', action.payload)
            state.layers.settings = action.payload
            localStorage.setItem('layers', JSON.stringify(state.layers))
        },


    }
})

export const { setObjects, updateObjects, clearObjects, setUser, logoutUser, setFilter, setCurrentComplex, setIsLoading, setError, setBaseLayer, setOverlayLayer, setDataLayer, setMapSettings } = storeSlice.actions

export default storeSlice.reducer 